import * as Types from "../Constants/AllConstants";

// ========== SEND EMAIL REDUCERS ==========

/**
 * Reducer for sending emails (manual, mailing list, CSV)
 * Combines all send operations into one reducer
 */
export const EmailSendReducer = (state = {}, action) => {
  switch (action.type) {
    // Request states
    case Types.SEND_EMAIL_REQUEST:
    case Types.SEND_EMAIL_MAILING_LIST_REQUEST:
    case Types.SEND_EMAIL_MAILING_LIST_BULK_REQUEST:
    case Types.SEND_EMAIL_CSV_REQUEST:
      return { loading: true };
    
    // Success states
    case Types.SEND_EMAIL_SUCCESS:
    case Types.SEND_EMAIL_MAILING_LIST_SUCCESS:
    case Types.SEND_EMAIL_MAILING_LIST_BULK_SUCCESS:
    case Types.SEND_EMAIL_CSV_SUCCESS:
      return { loading: false, success: true, batch: action.payload };
    
    // Fail states
    case Types.SEND_EMAIL_FAIL:
    case Types.SEND_EMAIL_MAILING_LIST_FAIL:
    case Types.SEND_EMAIL_MAILING_LIST_BULK_FAIL:
    case Types.SEND_EMAIL_CSV_FAIL:
      return { loading: false, error: action.payload };
    
    // Reset state
    case Types.SEND_EMAIL_RESET:
      return {};
    
    default:
      return state;
  }
};

// ========== FETCH EMAIL REDUCERS ==========

/**
 * Reducer for fetching all emails (non-paged)
 */
export const MyEmailsReducer = (state = { emails: [] }, action) => {
  switch (action.type) {
    case Types.MY_EMAILS_REQUEST:
      return { loading: true, emails: state.emails }; // Keep existing emails while loading
    case Types.MY_EMAILS_SUCCESS:
      return { loading: false, emails: action.payload };
    case Types.MY_EMAILS_FAIL:
      return { loading: false, error: action.payload, emails: state.emails };
    default:
      return state;
  }
};

/**
 * Reducer for fetching emails with pagination
 * Now supports immediate updates when emails are sent
 */
export const MyEmailsPagedReducer = (state = { emails: [] }, action) => {
  switch (action.type) {
    case Types.MY_EMAILS_PAGED_REQUEST:
      return { ...state, loading: true };
    
    case Types.MY_EMAILS_PAGED_SUCCESS:
      return {
        loading: false,
        emails: action.payload.content,
        page: action.payload.number,
        pages: action.payload.totalPages,
        totalElements: action.payload.totalElements,
      };
    
    case Types.MY_EMAILS_PAGED_FAIL:
      return { ...state, loading: false, error: action.payload };
    
    // Optimistically add new email when sent successfully
    case Types.SEND_EMAIL_SUCCESS:
    case Types.SEND_EMAIL_MAILING_LIST_SUCCESS:
    case Types.SEND_EMAIL_CSV_SUCCESS:
      // Add the new batch info to the beginning of the emails array
      const newEmail = {
        id: action.payload.id,
        reference: action.payload.reference,
        sentAt: new Date().toISOString(),
        status: 'PENDING',
        // Add other relevant fields from the batch response
        ...action.payload
      };
      
      return {
        ...state,
        emails: [newEmail, ...state.emails],
        totalElements: (state.totalElements || 0) + 1,
      };
    
    default:
      return state;
  }
};

// ========== ADMIN EMAIL REDUCERS ==========

/**
 * Reducer for admin fetching all emails (non-paged)
 */
export const AdminEmailsReducer = (state = { emails: [] }, action) => {
  switch (action.type) {
    case Types.ADMIN_EMAILS_REQUEST:
      return { loading: true, emails: state.emails };
    case Types.ADMIN_EMAILS_SUCCESS:
      return { loading: false, emails: action.payload };
    case Types.ADMIN_EMAILS_FAIL:
      return { loading: false, error: action.payload, emails: state.emails };
    default:
      return state;
  }
};

/**
 * Reducer for admin fetching emails with pagination
 */
export const AdminEmailsPagedReducer = (state = { emails: [] }, action) => {
  switch (action.type) {
    case Types.ADMIN_EMAILS_PAGED_REQUEST:
      return { ...state, loading: true };
    case Types.ADMIN_EMAILS_PAGED_SUCCESS:
      return {
        loading: false,
        emails: action.payload.content,
        page: action.payload.number,
        pages: action.payload.totalPages,
        totalElements: action.payload.totalElements,
      };
    case Types.ADMIN_EMAILS_PAGED_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// ========== EMAIL STATISTICS REDUCER ==========

/**
 * Reducer for email statistics
 */
export const EmailStatisticsReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.EMAIL_STATISTICS_REQUEST:
      return { loading: true };
    case Types.EMAIL_STATISTICS_SUCCESS:
      return { loading: false, statistics: action.payload };
    case Types.EMAIL_STATISTICS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};